// How many alerts will get by Up/Down scrolling
export const ALERTS_PER_DIRECTION = 15;
// How many alerts+errors will be display in home screen
export const CONNECT_SHOW_LAST_ALERTS_COUNT = 5;

export const alertsDataDirection = {
    UP: 'UP',
    DOWN: 'DOWN',
    UP_DOWN: 'UP_DOWN'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/alerts/alerts.constant.js